import React from 'react';
import Link from '../../../common/components/Link/Link';
import List from '../../../common/components/List/List';
var Content = function (_a) {
    var content = _a.content, title = _a.title, header = _a.header;
    return (React.createElement("div", { className: 'timeline__content' },
        React.createElement("div", { className: 'timeline__content-header' }, header),
        React.createElement("div", { className: 'timeline__content-text' },
            React.createElement("div", { className: 'timeline__content-title' },
                React.createElement("div", { className: 'timeline__content-position' }, title.position),
                React.createElement("div", { className: 'timeline__content-company' },
                    React.createElement(Link, { href: title.company.url }, title.company.name))),
            React.createElement("div", { className: 'timeline__content-subtitle' },
                React.createElement(List, { items: content })))));
};
export default Content;
